import { Box, Paper } from "@mui/material";
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/icons/menu/logo.svg";
import slots from "../../assets/icons/menu/slots.svg";
import live from "../../assets/icons/menu/live_casino.svg";
import bonuses from "../../assets/icons/menu/bonuses.svg";
import mobile_menu from "../../assets/icons/menu/mobile_menu.svg";
import close from "../../assets/icons/menu/close.svg";
import "./mobile.bar.css";

interface IMobileBarProps {
  menuOpened: boolean;
  setMenuOpened: React.Dispatch<React.SetStateAction<boolean>>;
}
export const MobileBar = ({ menuOpened, setMenuOpened }: IMobileBarProps) => {
  const { t } = useTranslation();
  return (
    <Box
      className="mobile-bar"
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
    >
      <Box className="mobile-bar__container">
        <Box
          id="menu-item-1"
          className={
            menuOpened ? "mobile-bar__item active" : "mobile-bar__item"
          }
          onClick={() => {
            setMenuOpened(!menuOpened);
          }}
        >
          {!menuOpened ? (
            <img src={mobile_menu} alt="Menu" />
          ) : (
            <img src={close} alt="Close" />
          )}
          <Box
            sx={{
              fontSize: "12px",
              color: "var(--primary-text-color)",
            }}
          >
            <p>{t("main.menuItems.menu")}</p>
          </Box>
        </Box>
        <NavLink
          to="/lobby/slots"
          id="menu-item-2"
          className={({ isActive }) => {
            if (isActive && !menuOpened) {
              return "mobile-bar__item active";
            } else {
              return "mobile-bar__item";
            }
          }}
          onClick={() => {
            setMenuOpened(false);
          }}
          end
        >
          <img src={slots} alt="Slots" />
          <Box
            sx={{
              fontSize: "12px",
              color: "var(--primary-text-color)",
            }}
          >
            <p>{t("main.menuItems.slots")}</p>
          </Box>
        </NavLink>
        <NavLink
          to="/"
          id="menu-item-3"
          className={({ isActive }) => {
            if (isActive && !menuOpened) {
              return "mobile-bar__item active";
            } else {
              return "mobile-bar__item";
            }
          }}
          onClick={() => {
            setMenuOpened(false);
          }}
          end
        >
          <img src={logo} alt="Enomo" />
          <Box
            sx={{
              fontSize: "12px",
              color: "var(--primary-text-color)",
            }}
          >
            <p>{t("main.menuItems.main")}</p>
          </Box>
        </NavLink>
        <NavLink
          to="/lobby/live"
          id="menu-item-4"
          className={({ isActive }) => {
            if (isActive && !menuOpened) {
              return "mobile-bar__item active";
            } else {
              return "mobile-bar__item";
            }
          }}
          onClick={() => {
            setMenuOpened(false);
          }}
          end
        >
          <img src={live} alt="Live Casino" />
          <Box
            sx={{
              fontSize: "12px",
              color: "var(--primary-text-color)",
            }}
          >
            <p>{t("main.menuItems.live_short")}</p>
          </Box>
        </NavLink>
        <NavLink
          to="/bonuses"
          id="menu-item-5"
          className={({ isActive }) => {
            if (isActive && !menuOpened) {
              return "mobile-bar__item active";
            } else {
              return "mobile-bar__item";
            }
          }}
          onClick={() => {
            setMenuOpened(false);
          }}
        >
          <img src={bonuses} alt="Bonuses" />
          <Box
            sx={{
              fontSize: "12px",
              color: "var(--primary-text-color)",
            }}
          >
            <p>{t("main.menuItems.bonuses")}</p>
          </Box>
        </NavLink>
        <Box className="mobile-bar__circle"></Box>
      </Box>
    </Box>
  );
};
